// @flow
import React from 'react';
import classnames from 'classnames';

import { PriceOfStay } from 'Components/widgets/price-of-stay/PriceOfStay.jsx';
import { ResortBanner } from 'Components/widgets/resort-banner/ResortBanner';

type Props = {|
  product: Resort,
  className?: string,
  isExclusiveCollection: boolean,
|};

export const PriceRemoteTicket = (props: Props) => {
  const { product, className, isExclusiveCollection } = props;
  return (
    <div className={classnames(className, 'flex flex-grow justify-between')}>
      <ResortBanner product={product} isExclusiveCollection={isExclusiveCollection} />
      <div className="text-center w-full lg:w-auto lg:text-right lg:flex lg:flex-shrink-0 lg:items-center">
        <PriceOfStay productId={product.id} />
      </div>
    </div>
  );
};
